const firebaseConfig = {
    apiKey: "AIzaSyDzhHaJcDNsfSpcXEsAZnjVK2r6cuekXFI",
    authDomain: "computer-bangladesh.firebaseapp.com",
    projectId: "computer-bangladesh",
    storageBucket: "computer-bangladesh.appspot.com",
    messagingSenderId: "183786871917",
    appId: "1:183786871917:web:8fab495e9b85b8f4bc7364"
  };

export default firebaseConfig;  